var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid block-typical" }, [
    _c("h2", [_vm._v("Radio")]),
    _c("div", { staticClass: "row ui-block" }, [
      _c(
        "div",
        { staticClass: "col-3" },
        [
          _c("h5", [_vm._v("Basic")]),
          _c(
            "el-radio",
            {
              attrs: { label: "1" },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [_vm._v("Option A")]
          ),
          _c(
            "el-radio",
            {
              attrs: { label: "2" },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [_vm._v("Option B")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-3" },
        [
          _c("h5", [_vm._v("Disabled")]),
          _c(
            "el-radio",
            {
              attrs: { disabled: "", label: "disabled" },
              model: {
                value: _vm.radio1,
                callback: function ($$v) {
                  _vm.radio1 = $$v
                },
                expression: "radio1",
              },
            },
            [_vm._v("Option A")]
          ),
          _c(
            "el-radio",
            {
              attrs: { disabled: "", label: "selected and disabled" },
              model: {
                value: _vm.radio1,
                callback: function ($$v) {
                  _vm.radio1 = $$v
                },
                expression: "radio1",
              },
            },
            [_vm._v("Option B")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-3" },
        [
          _c("h5", [_vm._v("Radio button group")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.radio2,
                callback: function ($$v) {
                  _vm.radio2 = $$v
                },
                expression: "radio2",
              },
            },
            [
              _c("el-radio", { attrs: { label: 3 } }, [_vm._v("Option A")]),
              _c("el-radio", { attrs: { label: 6 } }, [_vm._v("Option B")]),
              _c("el-radio", { attrs: { label: 9 } }, [_vm._v("Option C")]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "row ui-block" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("h5", [_vm._v("Radio Button style")]),
        _c(
          "div",
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.radio3,
                  callback: function ($$v) {
                    _vm.radio3 = $$v
                  },
                  expression: "radio3",
                },
              },
              [
                _c("el-radio-button", { attrs: { label: "New York" } }),
                _c("el-radio-button", { attrs: { label: "Washington" } }),
                _c("el-radio-button", { attrs: { label: "Los Angeles" } }),
                _c("el-radio-button", { attrs: { label: "Chicago" } }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "medium" },
                    model: {
                      value: _vm.radio4,
                      callback: function ($$v) {
                        _vm.radio4 = $$v
                      },
                      expression: "radio4",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "New York" } }),
                    _c("el-radio-button", { attrs: { label: "Washington" } }),
                    _c("el-radio-button", { attrs: { label: "Los Angeles" } }),
                    _c("el-radio-button", { attrs: { label: "Chicago" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.radio5,
                      callback: function ($$v) {
                        _vm.radio5 = $$v
                      },
                      expression: "radio5",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "New York" } }),
                    _c("el-radio-button", {
                      attrs: { label: "Washington", disabled: "" },
                    }),
                    _c("el-radio-button", { attrs: { label: "Los Angeles" } }),
                    _c("el-radio-button", { attrs: { label: "Chicago" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { disabled: "", size: "mini" },
                    model: {
                      value: _vm.radio6,
                      callback: function ($$v) {
                        _vm.radio6 = $$v
                      },
                      expression: "radio6",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "New York" } }),
                    _c("el-radio-button", { attrs: { label: "Washington" } }),
                    _c("el-radio-button", { attrs: { label: "Los Angeles" } }),
                    _c("el-radio-button", { attrs: { label: "Chicago" } }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-6" }, [
        _c("h5", [_vm._v("Radio Button With borders")]),
        _c(
          "div",
          [
            _c(
              "el-radio",
              {
                attrs: { label: "1", border: "" },
                model: {
                  value: _vm.radio7,
                  callback: function ($$v) {
                    _vm.radio7 = $$v
                  },
                  expression: "radio7",
                },
              },
              [_vm._v("Option A")]
            ),
            _c(
              "el-radio",
              {
                attrs: { label: "2", border: "" },
                model: {
                  value: _vm.radio7,
                  callback: function ($$v) {
                    _vm.radio7 = $$v
                  },
                  expression: "radio7",
                },
              },
              [_vm._v("Option B")]
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: "1", border: "", size: "medium" },
                    model: {
                      value: _vm.radio8,
                      callback: function ($$v) {
                        _vm.radio8 = $$v
                      },
                      expression: "radio8",
                    },
                  },
                  [_vm._v("Option A")]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: "2", border: "", size: "medium" },
                    model: {
                      value: _vm.radio8,
                      callback: function ($$v) {
                        _vm.radio8 = $$v
                      },
                      expression: "radio8",
                    },
                  },
                  [_vm._v("Option B")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.radio9,
                      callback: function ($$v) {
                        _vm.radio9 = $$v
                      },
                      expression: "radio9",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1", border: "" } }, [
                      _vm._v("Option A"),
                    ]),
                    _c(
                      "el-radio",
                      { attrs: { label: "2", border: "", disabled: "" } },
                      [_vm._v("Option B")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "mini", disabled: "" },
                    model: {
                      value: _vm.radio10,
                      callback: function ($$v) {
                        _vm.radio10 = $$v
                      },
                      expression: "radio10",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1", border: "" } }, [
                      _vm._v("Option A"),
                    ]),
                    _c("el-radio", { attrs: { label: "2", border: "" } }, [
                      _vm._v("Option B"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }